
import { JsonServiceClient } from '@servicestack/client';
import { useMemo } from 'react';
import useSWR, { SWRConfiguration, SWRResponse } from 'swr';
import { client } from '../api/client';
import { GeneratedEmailResponse, GenerateInvoiceEmail } from '../api/dtos';
import { useGet } from '@ngt/forms';

const getData = (response?: SWRResponse<GeneratedEmailResponse, GeneratedEmailResponse>) => response?.data?.result;

const getError = (response?: SWRResponse<GeneratedEmailResponse, GeneratedEmailResponse>) => (response?.error ?? response?.data);

const getAdditionalState = (response?: SWRResponse<GeneratedEmailResponse, GeneratedEmailResponse>) => ({
    invoice: response?.data?.result
});

export const useInvoice = (reg?: number, configuration?: SWRConfiguration) => {
    const request = useMemo(() => {

        return () => {
            return new GenerateInvoiceEmail({registrationId: reg});
        };
    }, [reg])

    return useGet(request, { getData, getError, getAdditionalState}, configuration);
};

export default useInvoice;

